import { h, render } from 'preact';
import { setup } from 'goober';
import { ConfigProvider } from './providers/ConfigProvider';
import { UnifiedWidgetProvider } from './providers/UnifiedWidgetProvider';
import { UnifiedWidget } from './UnifiedWidget';

setup(h);

const App = () => {
  return (
    <ConfigProvider>
      <UnifiedWidgetProvider>
        <UnifiedWidget />
      </UnifiedWidgetProvider>
    </ConfigProvider>
  );
};

const initWidget = () => {
  const root = document.createElement("div");
  root.id = "sa-unified-widget";
  document.body.appendChild(root);
  render(<App />, root);
};

// Global API
if (typeof window !== 'undefined') {
  window.UnifiedWidget = window.UnifiedWidget || {
    init: (config: any) => {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
          window.UnifiedWidgetConfig = config;
          initWidget();
        });
      } else {
        window.UnifiedWidgetConfig = config;
        initWidget();
      }
    }
  };

  // Auto-initialize if config is already available
  const existingConfig = (window as any).UnifiedWidgetConfig;
  if (existingConfig) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initWidget);
    } else {
      initWidget();
    }
  }
}

